<script lang="ts">
    import type {DefinedAction} from '../../services/defined-action-performer';
    import KpButton from '../../ui-components/button/KpButton.svelte';
    import {getInjector} from '../../../svelte/context';
    import DefinedActionPerformer from '../../services/defined-action-performer';
    import type {ComponentSize, ButtonStyle} from '../../ui-components/types';

    export let action: DefinedAction;
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let isDisabled = false;
    export let title = '';
    export let additionalClasses = '';
    export let id: string = null;

    const definedActionPerformer = getInjector().getByToken<DefinedActionPerformer>(DefinedActionPerformer.serviceName);

    function performAction() {
        definedActionPerformer.performAction(action);
    }
</script>

<template>
    <KpButton {buttonStyle} {buttonSize} {isDisabled} {title} {isBlock} additionalClasses="kp-defined-action-button {additionalClasses}" {id} on:click={performAction}>
        <slot></slot>
    </KpButton>
</template>